import { Component } from '@angular/core';
import { Subscription } from '../../../my-greyhound/profile/subscriptions/subscriptions.component';
import { FormGroup, FormArray, FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { InitialDataService } from 'app/initial-data.service';
import { MyGreyhoundService, SubscriptionOption, SubscriptionOptionItem } from 'app/my-greyhound/my-greyhound.service';
import { ActionUpdaterService, ApiError } from '../../services/action-updater.service';
import * as _ from 'lodash';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'gaweb-update-subscriptions',
    templateUrl: './update-subscriptions.component.html'
})
export class UpdateSubscriptionsComponent {
    unsubscribed: boolean;
    private subscriptions: Subscription[];
    subscriptionForm: FormGroup;
    items: FormArray;
    userId: string;
    userGuid: string;
    isMyGreyhound: boolean;
    loading = true;
    updating: boolean;
    anySubscribed: boolean;
    invalidGuid: boolean;
    siteLink: string;
    constructor(private initialData: InitialDataService,
        private fb: FormBuilder,
        private myGreyhoundService: MyGreyhoundService,
        private actionUpdaterService: ActionUpdaterService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private titleService: Title) {

        this.titleService.setTitle('Manage Subscriptions');
        this.subscriptionForm = this.fb.group({
            items: this.fb.array([])
        });
        this.activatedRoute.params.subscribe(params => {
            this.invalidGuid = false;
            this.isMyGreyhound = this.router.url.includes('/my-greyhound/');
            const idAndGuid: string = params['idAndGuid'];
            if (!!idAndGuid) {
                const firstDashIdx = idAndGuid.indexOf('-');
                this.userId = idAndGuid.substring(0, firstDashIdx);
                this.userGuid = idAndGuid.substring(firstDashIdx + 1);
                if (this.userGuid.length !== 36) {
                    this.invalidGuid = true;
                    this.loading = false;
                    this.userId = null
                    this.userGuid = null;
                    this.actionUpdaterService.announceError(new ApiError('Invalid Customer.'));
                    return;
                }
            } else {
                this.invalidGuid = true;
                window.location.href = this.isMyGreyhound ? '/my-greyhound' : 'https://www.ozexperience.com/my-experience';
            }
            if (this.isMyGreyhound) {
                this.siteLink = '/my-greyhound';
            } else {
                this.siteLink = 'https://www.ozexperience.com/my-experience';
            }
        });
        this.getSubscriptions();

    }
    getSubscriptions() {
        const onError = (error) => {
            this.invalidGuid = true;
            this.loading = false;
            this.actionUpdaterService.announceError(error);
        }
        this.anySubscribed = false;
        if (!!this.userGuid) {
            this.myGreyhoundService
                .getSubscriptions(this.userGuid)
                .subscribe((subs: Subscription[]) => {
                    this.invalidGuid = false;
                    this.subscriptions = subs;
                    this.items = this.subscriptionForm.get('items') as FormArray;
                    // this.items.reset();
                    // this.items = this.fb.array([]);

                    _.forEach(this.items.controls, (item, index) => {
                        this.items.removeAt(index);
                    });
                    _.forEach(this.subscriptions, (sub: Subscription, index) => {
                        this.items.controls[index] = this.fb.control(sub.IsSubscribed);
                        this.anySubscribed = this.anySubscribed || sub.IsSubscribed;
                    });
                    this.loading = false;
                }, onError);
        } else {
            this.loading = false;
        }

    }
    onUpdatingSubscriptions() {
        const subscriptionOptionItems: Array<SubscriptionOptionItem> = [];
        _.forEach(this.subscriptions, (sub, index) => {
            const selected = this.items.get('' + index).value;
            const page = "manage";
            const isGreyhound = this.isMyGreyhound;
            subscriptionOptionItems.push(new SubscriptionOptionItem(sub.NewsLetterID, selected, page, isGreyhound ));
        });
        const options = new SubscriptionOption(subscriptionOptionItems);

        const onError = (error: ApiError) => {
            this.unsubscribed = false;
            this.updating = false;
            this.actionUpdaterService.announceError(error);
        }
        this.updating = true;
        this.myGreyhoundService
            .updateSubscriptions(options, this.userGuid)
            .subscribe((subs) => {
                this.updating = false;
                this.unsubscribed = true;
                this.actionUpdaterService.announceSuccess('Subscriptions updated');
            }, onError);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/update-subcriptions/update-subscriptions.component.ts